import React from 'react';
import { Link } from 'react-router-dom';
import { UsersRound } from 'lucide-react';
import { useApi } from '../../lib/api';
import { money } from '../../lib/constants';
import { Button } from '../ui/button';

export const StaffPricingConfiguration = () => {
  const { data, error, reload } = useApi('/owner/staff-pricing');
  return <section data-testid="system-staff-pricing" className="max-w-2xl space-y-6">
    {error && <div data-testid="system-pricing-error" role="alert" className="owner-warning">{error}<Button data-testid="system-pricing-retry" variant="ghost" onClick={reload}>Retry</Button></div>}
    {data ? <dl className="owner-service-list">
      <div><dt>Yearly shop subscription</dt><dd data-testid="system-base-fee">€{money(data.baseYearlyFee)}</dd></div>
      <div><dt>Included staff slots</dt><dd data-testid="system-included-staff">{data.includedStaff} · shop admin excluded</dd></div>
      <div><dt>Extra staff slot / year</dt><dd data-testid="system-extra-staff-fee">€{money(data.extraStaffYearlyFee)}</dd></div>
    </dl> : !error && <p data-testid="system-pricing-loading" className="owner-muted">Loading subscription pricing…</p>}
    <Button asChild className="owner-primary"><Link data-testid="system-manage-staff-allowances" to="/owner/shops/staff"><UsersRound size={16} className="mr-2" />Manage staff allowances</Link></Button>
  </section>;
};